module.exports = __webpack_public_path__ + "static/media/wedding7.f95ae0a3.jpg";